module.exports = __webpack_public_path__ + "static/media/0006.17f0432d.jpg";